import { render, staticRenderFns } from "./downloadCertificatePage.vue?vue&type=template&id=53016c68&scoped=true"
import script from "./downloadCertificatePage.vue?vue&type=script&lang=ts"
export * from "./downloadCertificatePage.vue?vue&type=script&lang=ts"
import style0 from "./downloadCertificatePage.vue?vue&type=style&index=0&id=53016c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53016c68",
  null
  
)

export default component.exports